export class WebhusetApiError extends Error {
  public errCode: number;

  constructor(errCode: number) {
    super(String(errCode));
    this.errCode = errCode;
  }
}
